import { animate, inView, scroll } from 'motion';

document.querySelectorAll('#milestone').forEach((milestone) => {
  inView(
    milestone,() =>{
    animate(milestone, { opacity: [0, 1] }, { duration: 1.8 }, );
  }
,
{margin: '0px 0px -40% 0px'}
  );
});
